import React from 'react';
import { toArray } from 'lodash';
import PropTypes from 'prop-types';

import { STATIC_ROOT } from '../../../constants';

import SvgComponent from '../../SvgComponent';

import './Stepper.scss';

const Stepper = ({ cssClass, steps, current }) => {
    const stepsArray = toArray(steps);

    return (
        <div className={`stepper-container ${cssClass}`}>
            {stepsArray.map((value, index) => {
                const active = index <= current;
                const isFirst = index === 0;
                const validated = index < current;
                return (
                    <div className={`step-layout ${!isFirst && ' step-layout-flex'}`} key={value}>
                        {!isFirst && (
                            <div className="line-container">
                                <div
                                    className={`line-style ${
                                        !active ? 'step-inactive' : 'step-active'
                                    }`}></div>
                            </div>
                        )}
                        <div className="step-container">
                            <div className={`circle ${active ? 'step-active' : 'step-inactive'}`}>
                                {' '}
                                {validated && (
                                    <span className="check-icon">
                                        <SvgComponent
                                            src={`${STATIC_ROOT}/check.svg`}
                                            width="12"
                                            height="12"
                                        />
                                    </span>
                                )}
                            </div>
                            <p
                                className={`hide-mobile ${
                                    active ? 'label-active' : 'label-inactive'
                                }`}>
                                {value}
                            </p>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

Stepper.propTypes = {
    cssClass: PropTypes.string,
    steps: PropTypes.arrayOf(PropTypes.shape({})),
    current: PropTypes.number.isRequired
};

Stepper.defaultProps = {
    steps: []
};

export default Stepper;



// WEBPACK FOOTER //
// ./src/components/pages/ebon/Stepper.js